
export default {
  props: {
    fnConfirm: {
      type: Function,
      default: function _default() {}
    },
    row: {
      type: Object,
      default: function _default() {}
    },
    btnText: {
      type: String,
      default: '删除'
    },
    icon: {
      type: String
    },
    type: {
      type: String
    },
    btnType: {
      type: String,
      default: 'danger'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    btnTextContent: String
  },
  data: function data() {
    return {
      visible: false
    };
  },

  methods: {
    handleConfirm: function handleConfirm() {
      if (this.fnConfirm) {
        this.fnConfirm(this.row);
      }
      this.$emit('confirm', this.row);
      this.visible = false;
    }
  }
};